export class ModalStack {
    private static count = 0;

    private static openModals: number[] = [];

    static isVisible(id: number) {
        if (this.openModals.indexOf(id) < 0) {
            this.openModals.push(id);
        }
        this.onChange();
    }

    static isHidden(id: number) {
        const index = this.openModals.indexOf(id);
        if (index >= 0) {
            this.openModals.splice(index, 1);
        }

        this.onChange();
    }

    static getId() {
        return ++this.count;
    }

    private static onChange() {
        if (this.openModals.length === 0) {
            document.body.classList.remove('inline-modal-open');
        } else {
            document.body.classList.add('inline-modal-open');
        }
    }
}
